<template>
  <div class="instruct-wrapper">
    <div class="instuctor-process-options">
      <WidgetToolbar title="Instructor" :icon="require('@/assets/admin-icon/menu/instructor_active.svg')">
        <div class="options row">
          <widgetSearch placeholder="Search here..." icon="right" v-model="filter_form.query" @keyup="searchStudent">
          </widgetSearch>
          <div class="h-spacer"></div>
          <classDropdown :school="$getLoggedUser().company_name" @onSubmit="getSelectedClass">
            <span class="selected-class" v-if="!filter_form.class">
              All Departments
            </span>
            <span class="selected-class" v-else>{{
              filter_form.class.data.name
            }}</span>
          </classDropdown>

          <div class="v-line-divider" style="height: 40px"></div>
          <div class="table-options">
            <SchoolNotifiation></SchoolNotifiation>
          </div>
          <dropdown-menu v-if="show_selected_student_options" class="table-menu">
            <ul>
              <li>
                <a @click.prevent="remindSelectedStudent()">Remind</a>
              </li>
              <li>
                <app-dialog title="Delete Student" ask="Are you sure you want to delete selected student?" yesText="Yes"
                  noText="No" @onComfirm="deleteSelectedStudent()">
                  <a>Delete</a>
                </app-dialog>
              </li>
              <li>
                <a @click.prevent="exportSelectedStudent()">Export</a>
              </li>
            </ul>
          </dropdown-menu>
        </div>
      </WidgetToolbar>
    </div>
    <div class="instruct-widget">
      <instructorProcessMenus></instructorProcessMenus>
      <div class="instruct-list">
        <div class="instruct-body" @scroll="onPageScoll"
          v-if="student_data && student_data.data.length > 0 && !isLoading">
          <table class="table-data">
            <thead class="table-header">
              <tr class="stack-title">
                <th class="stick-title">
                  <div class="force-start">
                    <input v-model="isAllStudentSelected" @change="checkAllStudent" type="checkbox" />
                    Name
                  </div>
                </th>
                <th class="stick-title">Email</th>
                <th class="stick-title">LIA</th>
                <th class="stick-title">Rating</th>
                <th class="stick-title">Profile Update</th>
                <th class="stick-title" width="90">More actions</th>
              </tr>
            </thead>
            <tbody class="table-body">
              <template>
                <tr v-for="(item, index) in student_data.data" :key="index" class="row-data">
                  <td>
                    <div class="profile-content">
                      <input @change="checkStudent" v-model="item.checked" class="checkbox" type="checkbox" />
                      <widgetProfile :title="item.first_name + ' ' + item.last_name"
                        :subtitle="item.profile ? item.profile.address : ''" :file_name="item.profile_picture"
                        :path="$fullUrl('images/profiles/')"></widgetProfile>
                    </div>
                  </td>
                  <td class="email">{{ item.email }}</td>
                  <td>
                    <div v-if="item.internship" class="applied-internship">
                      <widgetProfile class="active" :title="item.internship.name" :subtitle="item.internship.location">
                      </widgetProfile>
                    </div>
                  </td>
                  <td>
                    <star-rating v-if="item.profile &&
                      item.profile.rate_notification_sent &&
                      item.profile.rate
                      " inactive-color="#C1C1C1" active-color="#1BA5A4" :read-only="true" :rating="item.profile.rate"
                      :star-size="15" :padding="1" :show-rating="false"></star-rating>
                    <widgetButton v-if="item.profile && !item.profile.rate_notification_sent
                      " :loading="false" @click="sendRateCompanyNotification(item)" class="btn-secondary">
                      Rate company
                    </widgetButton>

                    <widgetBadget v-if="item.profile &&
                      item.profile.rate_notification_sent &&
                      !item.profile.rate
                      " class="badge-secondary" text="Sent"></widgetBadget>
                  </td>
                  <td>
                    <widgetButton v-if="item.profile &&
                      !item.profile.profile_update_notification &&
                      item.profile.completion < 100
                      " @click="sendUpdateProfileNotification(item)" class="btn-primary">
                      Update profile
                    </widgetButton>

                    <div v-if="item.profile &&
                      item.profile.profile_update_notification &&
                      item.profile.completion < 100
                      " class="progress-widget">
                      <progressBar v-if="item.profile" :style="{ width: '110px' }" :class="{
                        'p-danger': item.profile.completion < 35,
                        'p-warning':
                          item.profile.completion < 65 &&
                          item.profile.completion >= 35,
                        'p-success': item.profile.completion >= 65,
                      }" :showNumber="true" numberPosition="left" v-model="item.profile.completion">
                      </progressBar>
                    </div>

                    <widgetBadget v-if="item.profile &&
                      item.profile.profile_update_notification &&
                      item.profile.completion == 100
                      " class="badge-primary" text="Profile Updated">
                      <img class="icon" src="@/assets/icons/confirm_green.svg" />
                    </widgetBadget>
                  </td>
                  <td>
                    <div class="center">
                      <dropdown-menu class="table-menu">
                        <ul>
                          <li>
                            <a @click.prevent="viewProfile(item)">View Profile</a>
                          </li>
                          <li>
                            <a @click.prevent="sendMessage(item)">Send Message</a>
                          </li>
                          <li>
                            <a @click.prevent="sendRemainder(item)">Send Reminder</a>
                          </li>
                          <li>
                            <app-dialog title="Delete Student" ask="Are you sure you want to delete this student?"
                              yesText="Delete" noText="Cancel" @onComfirm="deleteStudent(item)">
                              <a>Delete Student</a>
                            </app-dialog>
                          </li>
                        </ul>
                      </dropdown-menu>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
          <!-- loading on pagination -->
          <div class="loading-paginated-items" v-if="isLoadingDataOnPagination">
            <loading :height="15" color="#1ba5a4" :opacity="1" :width="15" :active.sync="isLoadingDataOnPagination"
              :is-full-page="false" :can-cancel="false" background-color="#fff" class="loader"></loading>
          </div>
        </div>
        <!-- loading on pagination -->
        <div class="loading-paginated-items" v-if="isLoadingDataOnPagination">
          <loading :height="15" color="#1ba5a4" :opacity="1" :width="15" :active.sync="isLoadingDataOnPagination"
            :is-full-page="false" :can-cancel="false" background-color="#fff" class="loader"></loading>
        </div>
        <div v-if="student_data && student_data.data.length == 0 && !isLoading" class="student-not-found-widget">
          <widgetNotFoundWidget title="No Students Found"
            content="You need to complete the previous step to get students on this step">
            <img class="widget-img" src="@/assets/admin-icon/add-student-icon.svg" />
          </widgetNotFoundWidget>
        </div>
      </div>
    </div>

    <!-- Reminder modal -->
    <remainderModal v-if="show_remainder" :user="user_to_remaind" :type="remind_type" phase="phase_6"
      @close="closeRemainder">
    </remainderModal>
  </div>
</template>

<script>
import { eventBus } from "@/main";
import instructorProcessMenus from "./widgets/instructorProcessMenus.vue";
import remainderModal from "./modals/remainderModal.vue";
export default {
  name: "",
  components: {
    instructorProcessMenus,
    remainderModal,
  },
  props: {
    formFilter: {
      type: Object,
      default: () => {
        return {
          class: null,
          id: null,
          id_type: "",
          sort_by: "all",
          query: "",
        };
      },
    },
  },
  data: () => {
    return {
      view_filter: [
        {
          value: "all",
          name: "All Students",
        },
        {
          value: "has_company",
          name: "Has Company",
        },
        {
          value: "approved",
          name: "Approved Students",
        },
      ],
      student_data: null,
      filter_form: {
        id: null,
        id_type: "",
        query: "",
        class: null,
        url_type: "",
        next_page_url: "",
      },
      selected_school: null,
      show_remainder: false,
      user_to_remaind: null,
      report_data: {},
      remind_type: "student",
      show_selected_student_options: false,
      isLoading: false,
      isAllStudentSelected: false,
      isLoadingDataOnPagination: false,
    };
  },
  mounted() {
    let vm = this;
    vm.filter_form.class = vm.formFilter.class;
    vm.filter_form.id = vm.formFilter.id;
    vm.filter_form.id_type = vm.formFilter.id_type;
    vm.filter_form.query = vm.formFilter.query;
    vm.getAllStudent();
  },
  computed: {},
  watch: {},
  methods: {
    // =================================
    onPageScoll({ target }) {
      let vm = this;
      if (target.scrollTop + target.clientHeight >= target.scrollHeight - 100) {
        if (
          !vm.isLoadingDataOnPagination &&
          vm.student_data.current_page < vm.student_data.last_page
        ) {
          vm.getAllStudent("next");
        }
      }
    },
    searchStudent(e) {
      let vm = this;
      vm.$emit("saveFilter", "query", e.target.value);
      vm.isAllStudentSelected = false;
      vm.getAllStudent();
    },
    getSelectedClass(item) {
      let vm = this;
      vm.isAllStudentSelected = false;
      if (item.type == "school") {
        vm.filter_form.class = null;
        vm.filter_form.id = null;
        vm.filter_form.id_type = item.type;
        vm.$emit("saveFilter", "class", null);
        vm.$emit("saveFilter", "id", null);
        vm.$emit("saveFilter", "id_type", item.type);
        vm.getAllStudent();
      } else {
        vm.filter_form.class = item;
        vm.filter_form.id = item.data.id;
        vm.filter_form.id_type = item.type;
        vm.$emit("saveFilter", "class", item);
        vm.$emit("saveFilter", "id", item.data.id);
        vm.$emit("saveFilter", "id_type", item.type);
        vm.getAllStudent();
      }
    },
    getAllStudent(type = "init") {
      let vm = this;
      if (type == "init") {
        vm.isLoading = true;
      }

      vm.isLoadingDataOnPagination = true;
      vm.filter_form.url_type = type;
      vm.filter_form.next_page_url = vm.student_data
        ? vm.student_data.next_page_url
        : "";
      vm.$store
        .dispatch("GET_ALL_SCHOOL_STUDENT_PHASE4", vm.filter_form)
        .then((responce) => {
          vm.isLoadingDataOnPagination = false;
          vm.isLoading = false;
          responce.data.data = responce.data.data.map((item) => {
            if (vm.isAllStudentSelected) {
              eventBus.$set(item, "checked", true);
            } else {
              eventBus.$set(item, "checked", false);
            }

            if (item.internship) {
              let full_location = "";
              if (Array.isArray(item.internship.location)) {
                item.internship.location.forEach((location) => {
                  full_location += location + ", ";
                });
              }
              eventBus.$set(item.internship, "location", full_location);
            }

            return item;
          });
          if (type == "init") {
            vm.student_data = responce.data;
            if (vm.student_data.current_page < vm.student_data.last_page) {
              vm.getAllStudent("next");
            }
          } else {
            vm.student_data.next_page_url = responce.data.next_page_url;
            vm.student_data.current_page = responce.data.current_page;
            vm.student_data.last_page = responce.data.last_page;
            responce.data.data.forEach((item) => {
              vm.student_data.data.push(item);
            });
          }
          vm.validateCheckedStudent();
        })
        .catch((error) => {
          vm.isLoadingDataOnPagination = false;
          vm.isLoading = false;
        });
    },
    validateCheckedStudent(type = "validate") {
      let vm = this;
      if (type == "validate") {
        vm.show_selected_student_options =
          vm.student_data.data
            .map((item) => item.checked)
            .filter((item) => item == true).length > 0;
        return;
      }
      return vm.student_data.data
        .filter((item) => item.checked == true)
        .map((item) => item.id);
    },
    checkAllStudent({ target }) {
      let vm = this;
      vm.isAllStudentSelected = target.checked;
      if (target.checked) {
        vm.student_data.data = vm.student_data.data.map((item) => {
          eventBus.$set(item, "checked", true);
          return item;
        });
      } else {
        vm.student_data.data = vm.student_data.data.map((item) => {
          eventBus.$set(item, "checked", false);
          return item;
        });
      }
      vm.validateCheckedStudent();
    },
    checkStudent() {
      let vm = this;
      vm.isAllStudentSelected = false;
      vm.validateCheckedStudent();
    },
    // ==================================
    inviteSelectedStudent() {
      let vm = this;
      let payload = {
        ids: vm.validateCheckedStudent("ids"),
        isAllStudentSelected: vm.isAllStudentSelected,
        filter: vm.filter_form,
      };
      vm.$store
        .dispatch("INSTRUCTOR_SCHOOL_STUDENT_INVITE_SELECTED_PHASE6", payload)
        .then((responce) => {
          vm.getAllStudent();
          vm.$notify({
            group: "status",
            type: "success",
            title: "Mesage",
            text: "Invite sent",
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            type: "warn",
            title: "Warning",
            text: "Invitation not sent",
          });
        });
    },
    approveSelectedStudent() {
      let vm = this;
      let payload = {
        ids: vm.validateCheckedStudent("ids"),
        isAllStudentSelected: vm.isAllStudentSelected,
        filter: vm.filter_form,
      };
      vm.$store
        .dispatch("INSTRUCTOR_SCHOOL_STUDENT_APPROVE_SELECTED_PHASE6", payload)
        .then((responce) => {
          vm.getAllStudent();
          vm.$notify({
            group: "status",
            type: "success",
            title: "Mesage",
            text: "Selected student have been approved",
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            type: "warn",
            title: "Warning",
            text: "Something went wrong, Try again",
          });
        });
    },
    deleteSelectedStudent() {
      let vm = this;
      let payload = {
        ids: vm.validateCheckedStudent("ids"),
        isAllStudentSelected: vm.isAllStudentSelected,
        filter: vm.filter_form,
      };
      vm.$store
        .dispatch("INSTRUCTOR_SCHOOL_STUDENT_DELETE_SELECTED_PHASE1", payload)
        .then((responce) => {
          vm.getAllStudent();
          vm.$notify({
            group: "status",
            type: "success",
            title: "Mesage",
            text: "Selected student have been deleted",
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            type: "warn",
            title: "Warning",
            text: "Something went wrong, Try again",
          });
        });
    },
    exportSelectedStudent() {
      let vm = this;
      let payload = {
        ids: vm.validateCheckedStudent("ids"),
        isAllStudentSelected: vm.isAllStudentSelected,
        filter: vm.filter_form,
      };
      vm.$store
        .dispatch("INSTRUCTOR_SCHOOL_STUDENT_EXPORT_SELECTED_PHASE1", payload)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", Date.now() + "_student.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            type: "warn",
            title: "Warning",
            text: "Something went wrong, Try again",
          });
        });
    },
    remindSelectedStudent() {
      let vm = this;
      vm.user_to_remaind = vm.validateCheckedStudent("ids");
      vm.remind_type = "checked";
      vm.show_remainder = true;
    },
    // ==================================
    sendInvitation(item) {
      let vm = this;
      vm.$store
        .dispatch("INVITE_SCHOOL_STUDENT_PHASE6", { copy_id: item.copy })
        .then((responce) => {
          vm.getAllStudent();
          vm.$notify({
            group: "status",
            type: "success",
            title: "Mesage",
            text: "Invite sent",
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            type: "warn",
            title: "Warning",
            text: "Invitation not sent",
          });
        });
    },
    sendRateCompanyNotification(item) {
      let vm = this;
      vm.$store
        .dispatch("INSTRUCTOR_SEND_NOTIFICATION_RATE_COMPANY_PHASE6", {
          user_id: item.id,
        })
        .then((responce) => {
          vm.getAllStudent();
          vm.$notify({
            group: "status",
            type: "success",
            duration: 2000,
            text: "Notification sent successfully",
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            type: "warn",
            duration: 2000,
            text: "Error sending notification",
          });
        });
    },
    sendUpdateProfileNotification(item) {
      let vm = this;
      vm.$store
        .dispatch("INSTRUCTOR_SEND_NOTIFICATION_UPDATE_PROFILE_PHASE6", {
          user_id: item.id,
        })
        .then((responce) => {
          vm.getAllStudent();
          vm.$notify({
            group: "status",
            type: "success",
            duration: 2000,
            text: "Notification sent successfully",
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            type: "warn",
            duration: 2000,
            text: "Error sending notification",
          });
        });
    },
    remindAll(value) {
      let vm = this;
      vm.remind_type = value;
      vm.show_remainder = true;
    },
    sendRemainder(item) {
      let vm = this;
      vm.remind_type = "student";
      vm.user_to_remaind = item;
      vm.show_remainder = true;
    },
    closeRemainder() {
      let vm = this;
      vm.show_remainder = false;
    },
    sendMessage(item) {
      window.parent.postMessage({ message: "sendMessage", value: item }, "*");
    },
    deleteStudent(item) {
      let vm = this;
      vm.$store
        .dispatch("INSTRUCTOR_DELETE_SCHOOL_STUDENT", {
          student_id: item.id,
        })
        .then((responce) => {
          vm.getAllStudent();
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Student is now deleted",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    approveStudent(item) {
      let vm = this;
      vm.$store
        .dispatch("INSTRUCTOR_APPROVE_SCHOOL_STUDENT_PHASE6", {
          student_id: item.id,
        })
        .then((responce) => {
          vm.getAllStudent();
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Student profile is now approved",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    selectPath(item) {
      let vm = this;
      vm.$router.push({
        name: "instructor",
        params: { main_menu: item.main_name, sub_menu: item.name },
      });
    },
    viewProfile(item) {
      let item_id = window.btoa(item.id);
      let name =
        item.first_name.toLowerCase().replace(/\s/g, "-") +
        "-" +
        item.last_name.toLowerCase().replace(/\s/g, "-") +
        "-" +
        item_id;
      window.parent.postMessage(
        {
          message: "routeNow",
          value: {
            name: "consultant-public-profile",
            params: { name: name },
          },
        },
        "*"
      );
    },
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";

.instruct-wrapper {
  width: 100%;
  height: calc(100% - 0px);
  display: flex;
  flex-direction: column;

  .instuctor-process-options {
    position: absolute;
    top: 5px;
    right: 5px;
    left: 5px;
  }

  .instruct-widget {
    height: 100%;
    position: relative;

    .custom-resizer {
      height: 100%;
    }

    .instruct-list {
      display: flex;
      flex-direction: column;
      height: calc(100% - 40px);
      min-width: calc(100% - 300px);
      width: 100%;
      position: relative;

      .loading-widget {
        background: #fff;
        padding: 10px 10px;
        height: 100%;
        position: relative;
        border-radius: 10px;
        overflow: hidden;
      }

      .student-not-found-widget {
        background: #fff;
        padding: 10px 10px;
        height: 100%;
        position: relative;
        border-radius: 10px;
        overflow: hidden;
        display: flex;

        .notfound-wrapper {
          width: 100%;

          .notfound-widget {
            width: 500px;
          }
        }
      }

      .instruct-body {
        background: #fff;
        height: 100%;
        overflow-y: auto;
        padding-bottom: 60px;
        border-radius: 5px;
        padding: 10px;

        .table-data {
          border-collapse: collapse;
          border-spacing: 0;
          width: 100%;

          tr {
            &.row-data {
              background: #fff;
            }

            &:hover {
              background: rgb(248, 248, 248);
              cursor: pointer;
            }

            th {
              &.stick-title {
                position: sticky;
                top: 0px;
                z-index: 999;
              }

              &.center {
                display: flex;
                align-content: center;

                input {
                  position: relative;
                  top: 0px;
                  margin-right: 5px;
                  margin: 0px 20px;
                }
              }

              .force-start {
                display: flex;
                align-items: center;

                input {
                  position: relative;
                  top: -1px;
                  left: -7px;
                  margin-right: 5px;
                }
              }

              &.text-center {
                text-align: center;
              }
            }

            td {
              .checkbox {
                position: relative;
                top: -1px;
                left: -7px;
                margin-right: 5px;
              }

              .applied-internship {
                background: #f7f7f7;
                border-radius: 5px;
                padding: 1px 3px;
                margin: 4px 0px;
              }

              .profile-content {
                display: flex;
                align-items: center;
              }

              .invitation-status {
                padding: 13px 10px;
                width: 130px;
                border-radius: 10px;
                text-align: center;

                &.received {
                  border: 1px solid #1ba5a4;
                  color: #1ba5a4;
                }

                &.sent {
                  border: 1px solid #0884af;
                  color: #0884af;
                }
              }

              .approve-status {
                padding: 13px 10px;
                width: 110px;
                border-radius: 5px;
                text-align: center;

                span {
                  margin-right: 5px;
                }

                &.approved {
                  border: 1px solid #1ba5a4;
                  color: #1ba5a4;
                }
              }

              .progress-widget {
                width: 80px;
              }

              .table-menu {
                position: relative;
              }

              .center {
                display: flex;
                justify-content: center;
              }

              &:first-child {
                border-top-left-radius: 5px;
                border-bottom-left-radius: 5px;
              }

              &:last-child {
                border-top-right-radius: 5px;
                border-bottom-right-radius: 5px;
              }

              &.text-center {
                text-align: center;
              }

              &.email {
                color: #334d6eb0;
              }

              .btn-invite {
                width: 85px;
                height: 33px;
                background: #0884af;
                border-radius: 5px;
                color: #fff;
              }

              .btn-approve {
                width: 92px;
                height: 33px;
                background: #1ba5a4;
                border-radius: 5px;
                color: #fff;
              }
            }
          }
        }

        .loading-paginated-items {
          height: 50px;
          position: relative;
        }
      }
    }

    .instruct-details {
      width: 260px;
      min-width: 260px;
      max-width: 300px;
      display: flex;
      flex-direction: column;
      height: 100%;
      background: #fff;
      border-radius: 5px;

      .instruct-header {
        font-size: 24px;
        text-align: center;
        padding-top: 20px;
        margin-top: 33px;
        height: 48px;
        margin-bottom: 20px;

        h1 {
          margin: 0px;
          font-size: 25px;
          font-weight: 500;
        }
      }

      .instruct-body {
        height: calc(100% - 48px);
        overflow-y: auto;

        .chart-widget {
          width: 100%;
          border-radius: 5px;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          margin-bottom: 30px;

          .header {
            padding: 10px 10px;
            color: #333333;
            text-align: center;
          }

          .body {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 200px;
          }

          .footer {
            padding: 10px 10px;
            display: flex;
            justify-content: space-between;

            .label-widget {
              .box-widget {
                display: flex;
                align-items: center;

                .box {
                  height: 15px;
                  width: 15px;
                  background: #1ba5a4;
                  border-radius: 50%;
                  margin-right: 7px;

                  &.active {
                    background: #0884af;
                  }
                }

                .label {
                  font-size: 12px;
                  position: relative;
                  top: 3px;
                }
              }

              .label-info {
                margin-top: 8px;
                text-align: center;
              }
            }
          }
        }
      }

      .empty-widget {
        display: flex;
        align-content: center;
        justify-content: center;

        h1 {
          font-size: 20px;
          color: #ddd;
          margin-top: 200px;
        }
      }
    }
  }

  .form-widget-modal {
    width: 500px;
    min-height: 200px;
    padding: 20px;
  }

  .student-not-found-widget {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 5px;
  }
}

.search-contact-item {
  padding: 10px 15px;
  display: flex;
  cursor: pointer;
  align-items: center;

  img {
    border-radius: 50%;
    margin-right: 8px;
  }

  &:hover {
    background: rgb(250, 250, 250);
  }
}

.selected-search-contact-item {
  padding: 5px 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 1px solid #ddd;
  margin-top: 10px;
  border-radius: 15px;
  font-size: 11px;

  img {
    border-radius: 50%;
    margin-right: 8px;
  }

  &:hover {
    background: rgb(250, 250, 250);
  }
}
</style>
